import React from 'react'
import { EventRetentionRule, RetentionRule } from '../../../models/RetentionPolicy'

export const RetentionPolicyEventRuleBody: React.FC<{ retentionRule: RetentionRule }> = ({ retentionRule }) => {
  const rule = retentionRule as EventRetentionRule
  return (
    <>
      <div>
        <div>Rule</div>
        <div aria-label='Event name'>{rule.config.name}</div>
      </div>
    </>
  )
}
